import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import BodyView from "@/layout/BodyView.vue"
import AuthView from "@/components/common/block/auth/AuthView.vue"
import ResetPasswordFirstPage from "@/components/common/block/auth/ResetPasswordFirstPage.vue"
import LoginPage from "@/components/common/block/auth/LoginPage.vue"
import indexDefault from "@/pages/dashbords/indexDefault.vue"
import indexProject from "@/pages/dashbords/indexProject.vue"
import loginSimple from "@/pages/authentication/loginSimple.vue"
import loginImage from "@/pages/authentication/loginImage.vue"
import loginImageTwo from "@/pages/authentication/loginImageTwo.vue"
import loginValidation from "@/pages/authentication/loginValidation.vue"
import loginTooltip from "@/pages/authentication/loginTooltip.vue"
import loginSweetalert from "@/pages/authentication/loginSweetalert.vue"
import registerSimple from "@/pages/authentication/registerSimple.vue"
import registerImage from "@/pages/authentication/registerImage.vue"
import registerImageTwo from "@/pages/authentication/registerImageTwo.vue"
import unlockUser from "@/pages/authentication/unlockUser.vue"
import forgetPassword from "@/pages/authentication/forgetPassword.vue"
import resetPassword from "@/pages/authentication/resetPassword.vue"
import maintenanceView from "@/pages/authentication/maintenanceView.vue"
import AddPermissionPage from "@/pages/Permission/AddPermissionPage.vue";
import ListePermissionPage from "@/pages/Permission/ListePermissionPage.vue";
import ListeConditionnementPage from "@/pages/GesCom/Conditionnement/ListeConditionnementPage.vue"


import ListeMotifSuiviPage from '@/pages/GesCom/MotifSuivi/ListeMotifSuiviPage.vue';

import AddRolePage from "@/pages/Role/AddRolePage.vue";
import ListeRolePage from "@/pages/Role/ListeRolePage.vue";
import EditRolePage from "@/pages/Role/EditRolePage.vue";
import ViewRolePage from "@/pages/Role/ViewRolePage.vue";
import AddUserPage from '@/pages/Users/AddUserPage.vue';
import ListeUserPage from "@/pages/Users/ListeUserPage.vue";
import EditUserPage from "@/pages/Users/EditUserPage.vue";
import EditProfilePage from "@/pages/Users/EditProfilePage.vue";
import ViewUserPage from "@/pages/Users/ViewUserPage.vue";
import TableauBordPage from "@/pages/dashbords/TableauBordPage.vue"

//Gescom
import ListeFamillePage from "@/pages/GesCom/Familles/ListeFamillePage.vue";
import AddProduitPage from "@/pages/GesCom/Produit/AddProduitPage.vue";
import EditProduitPage from "@/pages/GesCom/Produit/EditProduitPage.vue";
import ListeProduitPage from "@/pages/GesCom/Produit/ListeProduitPage.vue";
import ViewProduitPage from "@/pages/GesCom/Produit/ViewProduitPage.vue";
import ListeMagasinPage from "@/pages/GesCom/Magasin/ListeMagasinPage.vue";
import AddInventairePage from "@/pages/GesCom/Inventaire/AddInventairePage.vue";

import AddPointVentePage from "@/pages/GesCom/PointVente/AddPointVentePage.vue";
import EditPointVentePage from "@/pages/GesCom/PointVente/EditPointVentePage.vue";
import ListePointVentePage from "@/pages/GesCom/PointVente/ListePointVentePage.vue";
import MiseAJourInventairePage from '@/pages/GesCom/Inventaire/MiseAJourInventairePage.vue';
import ListeProduitIventairePage from '@/pages/GesCom/Inventaire/ListeProduitIventairePage.vue';


//Etats

import AddMouvementPage from '@/pages/GesCom/Mouvement/AddMouvementPage.vue';
import ListMouvementPage from '@/pages/GesCom/Mouvement/ListeMouvementPage.vue';

import ApiService from '@/services/ApiService';

//Fin GesCom/

import { useAuthStore } from "@/services/auth";
import AddClientPage from '@/pages/GesCom/Client/AddClientPage.vue'
import EditClientPage from '@/pages/GesCom/Client/EditClientPage.vue'
import ViewClientPage from '@/pages/GesCom/Client/ViewClientPage.vue'
import ListeClientPage from '@/pages/GesCom/Client/ListeClientPage.vue'

import ListeGroupeTaxePage from '@/pages/GesCom/GroupeTaxe/ListeGroupeTaxePage.vue'
import ListeTypeTaxePage from '@/pages/GesCom/TypeTaxe/ListeTypeTaxePage.vue'
import ListeTaxePage from '@/pages/GesCom/Taxe/ListeTaxePage.vue'


import AddProduitConditionnementPage from '@/pages/GesCom/Produit/AddProduitConditionnementPage.vue'

import ListeBonCommandeFournisseurPage from '@/pages/GesCom/BonCommandeFournisseur/ListeBonCommandeFournisseurPage.vue'
import AddBonCommandeFournisseurPage from '@/pages/GesCom/BonCommandeFournisseur/AddBonCommandeFournisseurPage.vue'
import ViewBonCommandeFournisseurPage from '@/pages/GesCom/BonCommandeFournisseur/ViewBonCommandeFournisseurPage.vue'
import EditFournisseurPage from '@/pages/GesCom/Fournisseur/EditFournisseurPage.vue'
import ListeFournisseurPage from '@/pages/GesCom/Fournisseur/ListeFournisseurPage.vue'
import AddFournisseurPage from '@/pages/GesCom/Fournisseur/AddFournisseurPage.vue'
import ViewFournisseurPage from '@/pages/GesCom/Fournisseur/ViewFournisseurPage.vue'

import AddReglementPage from '@/pages/GesCom/Reglement/AddReglementPage.vue'
//import ListeClientPage from '@/pages/GesCom/Client/ListeClientPage.vue'
import AddModeReglementModal from '@/components/GesCom/ModeReglement/AddModeReglementModal.vue'
import ListeModeReglement from '@/components/GesCom/ModeReglement/ListeModeReglement.vue'
import AddDepotPage from '@/pages/GesCom/Depot/AddDepotPage.vue'
import ListeDepotPage from '@/pages/GesCom/Depot/ListeDepotPage.vue'
import ListeTypeComptePage from '@/pages/GesCom/TypeCompte/ListeTypeComptePage.vue'
import AddTransactionPage from '@/pages/GesCom/Transaction/AddTransactionPage.vue'
import EditTransactionPage from '@/pages/GesCom/Transaction/EditTransactionPage.vue'
import ViewTransactionPage from '@/pages/GesCom/Transaction/ViewTransactionPage.vue'
import EditComptePage from '@/pages/GesCom/Compte/EditComptePage.vue'
import ListeComptePage from '@/pages/GesCom/Compte/ListeComptePage.vue'
import AddComptePage from '@/pages/GesCom/Compte/AddComptePage.vue'

import ListeCompteEntreprisePage from '@/pages/GesCom/CompteEntreprise/ListeCompteEntreprisePage.vue'
import ListePiecePage from '@/pages/GesCom/Piece/ListePiecePage.vue'
import AddPiecePage from '@/pages/GesCom/Piece/AddPiecePage.vue'
import AddClientAffecterPage from '@/pages/GesCom/ClientAffecter/AddClientAffecterPage.vue'
import ListeClientAffecterPage from '@/pages/GesCom/ClientAffecter/ListeClientAffecterPage.vue'
import EditClientAffecterPage from '@/pages/GesCom/ClientAffecter/EditClientAffecterPage.vue'
import ClientsTransactionPage from '@/pages/GesCom/Client/ClientsTransactionPage.vue'
import AddMagasinPage from '@/pages/GesCom/Magasin/AddMagasinPage.vue'
import EditMagasinPage from '@/pages/GesCom/Magasin/EditMagasinPage.vue'
import ListeMesClientsPage from '@/pages/GesCom/MesClients/ListeMesClientsPage.vue'
import AddDemandePrixPage from '@/pages/GesCom/DemandePrix/AddDemandePrixPage.vue'
import AddVentePage from '@/pages/GesCom/Vente/AddVentePage.vue'
import TransformerProformaPage from '@/pages/GesCom/Vente/TransformerProformaPage.vue'
import ListeVentePage from '@/pages/GesCom/Vente/ListeVentePage.vue'
import ViewVentePage from '@/pages/GesCom/Vente/ViewVentePage.vue'
import EtatProduitsDisponibles from '@/pages/GesCom/Etats/EtatProduitsDisponibles.vue'
import EtatPointProduitLivraisonPage from '@/pages/GesCom/Etats/EtatPointProduitLivraisonPage.vue'
import EtatNombreProduitVenduPage from '@/pages/GesCom/Etats/EtatNombreProduitVenduPage.vue'
import EtatChiffreAffaireClientPage from '@/pages/GesCom/Etats/EtatChiffreAffaireClientPage.vue'
import EtatPointVentePage from '@/pages/GesCom/Etats/EtatPointVentePage.vue'
import EtatProduitsRupturePage from '@/pages/GesCom/Etats/EtatProduitsRupturePage.vue'
import EtatPointCommandePage from '@/pages/GesCom/Etats/EtatPointCommandePage.vue'
import EtatProduitsEntreePage from '@/pages/GesCom/Etats/EtatProduitsEntreePage.vue'
import EtatProduitsSortiesPage from '@/pages/GesCom/Etats/EtatProduitsSortiesPage.vue'
import AddDetachementPage from '@/pages/GesCom/Detachement/AddDetachementPage.vue'
import ListeDetachementPage from '@/pages/GesCom/Detachement/ListeDetachementPage.vue'
import ViewDetachementPage from '@/pages/GesCom/Detachement/ViewDetachementPage.vue'
import AddSortiePage from '@/pages/GesCom/Sortie/AddSortiePage.vue'
import EditSortiePage from '@/pages/GesCom/Sortie/EditSortiePage.vue'
import ListeSortiePage from '@/pages/GesCom/Sortie/ListeSortiePage.vue'
import ViewSortiePage from '@/pages/GesCom/Sortie/ViewSortiePage.vue'
import AddTransfertMagPage from '@/pages/GesCom/Transfert/AddTransfertMagPage.vue'
import AddTransfertPointVentePage from '@/pages/GesCom/Transfert/AddTransfertPointVentePage.vue'
import ListeTransfertPage from '@/pages/GesCom/Transfert/ListeTransfertPage.vue'
import ListeTransfertMagasinPage from '@/pages/GesCom/Transfert/ListeTransfertMagasinPage.vue'
import ViewTransfertMagasinPage from '@/pages/GesCom/Transfert/ViewTransfertMagasinPage.vue'
import ViewTransfertPage from '@/pages/GesCom/Transfert/ViewTransfertPage.vue'
import AddApprovisionnementPage from '@/pages/GesCom/Approvisionnement/AddApprovisionnementPage.vue'
import ListeApprovisionnementPage from '@/pages/GesCom/Approvisionnement/ListeApprovisionnementPage.vue'
import ViewApprovisionnementPage from '@/pages/GesCom/Approvisionnement/ViewApprovisionnementPage.vue'
import ViewLivraisonPage from '@/pages/GesCom/Livraison/ViewLivraisonPage.vue'
import ListeLivraisonPage from '@/pages/GesCom/Livraison/ListeLivraisonPage.vue'
import AddLivraisonPage from '@/pages/GesCom/Livraison/AddLivraisonPage.vue'
import AddCaissePage from '@/pages/GesCom/Caisse/AddCaissePage.vue'
import AddFermPage from '@/pages/GesCom/OuvFerm/AddFermPage.vue'
import AddOuvFermPage from '@/pages/GesCom/OuvFerm/AddOuvFermPage.vue'
import ListeCaissePage from '@/pages/GesCom/Caisse/ListeCaissePage.vue'
import ViewOuvFermPage from '@/pages/GesCom/OuvFerm/ViewOuvFermPage.vue'
import ListeMonnaiesDisponiblesPage from '@/pages/GesCom/OuvFerm/ListeMonnaiesDisponiblesPage.vue'
import ListeOuvFermPage from '@/pages/GesCom/OuvFerm/ListeOuvFermPage.vue'
import ListeMonnaiePage from '@/pages/GesCom/Monnaie/ListeMonnaiePage.vue'
import AddMonnaiePage from '@/pages/GesCom/Monaie/AddMonnaiePage.vue'
import ListeFacturePage from '@/pages/GesCom/Facture/ListeFacturePage.vue'
import ListeFactureProformaPage from '@/pages/GesCom/FactureProforma/ListeFactureProformaPage.vue'

import AddPaiementPage from '@/pages/GesCom/Paiement/AddPaiementPage.vue'
import ListePaiementPage from '@/pages/GesCom/Paiement/ListePaiementPage.vue'
import ViewPaiementPage from '@/pages/GesCom/Paiement/ViewPaiementPage.vue'
import EditSocietePage from '@/pages/GesCom/Societe/EditSocietePage.vue'
import ListeSocietePage from '@/pages/GesCom/Societe/ListeSocietePage.vue'
import ViewSocietePage from '@/pages/GesCom/Societe/ViewSocietePage.vue'
import AddSocietePage from '@/pages/GesCom/Societe/AddSocietePage.vue'
import ListeDemandePrixPage from '@/pages/GesCom/DemandePrix/ListeDemandePrixPage.vue'
import ViewDemandePrixPage from '@/pages/GesCom/DemandePrix/ViewDemandePrixPage.vue'
import EditDemandePrixPage from '@/pages/GesCom/DemandePrix/EditDemandePrixPage.vue'

import AddModeleSignatairePage from '@/pages/GesCom/ModeleSignataire/AddModeleSignatairePage.vue'
import ListeModeleSignatairePage from '@/pages/GesCom/ModeleSignataire/ListeModeleSignatairePage.vue'

import ConfirmationPaiementPage from '@/pages/GesCom/OuvFerm/ConfirmationPaiementPage.vue'
import ListeTypeDocumentPage from '@/pages/GesCom/TypeDocument/ListeTypeDocumentPage.vue'
import AddTypeDocumentModalPage from '@/pages/GesCom/TypeDocument/AddTypeDocumentModalPage.vue'
import ConversionMonnaiePage from '@/pages/GesCom/Operations/ConversionMonnaiePage.vue'
import AddDecaissementPage from '@/pages/GesCom/Operations/AddDecaissementPage.vue'
import AddEncaissementPage from '@/pages/GesCom/Operations/AddEncaissementPage.vue'
import ListeOperationPage from '@/pages/GesCom/Operation/ListeOperationPage.vue'
import AffectationCaisseModalPage from '@/pages/GesCom/AffectationCaisse/AffectationCaisseModalPage.vue'
import HistoriquePage from '@/pages/GesCom/AffectationCaisse/HistoriquePage.vue'
import ListeReglementPage from '@/pages/GesCom/Reglement/ListeReglementPage.vue'
import EditeFicheInventairePage from '@/pages/GesCom/Inventaire/EditeFicheInventairePage.vue'
import DetailInventairePage from '@/pages/GesCom/Inventaire/DetailInventairePage.vue'
import AddMouvementFichePage from '@/pages/GesCom/MouvementFiche/AddMouvementFichePage.vue'
import ListeMouvementFichePage from '@/pages/GesCom/MouvementFiche/ListeMouvementFichePage.vue'
import ListeFicheInventairePage from '@/pages/GesCom/Inventaire/ListeFicheInventairePage.vue'
import ListeInventairePage from '@/pages/GesCom/Inventaire/ListeInventairePage.vue'


const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: BodyView,
    meta: {
      title: 'Romas progiciel',
    },
    children: [
      {
        path: '',
        name: 'TableauBord',
        component: TableauBordPage,
        meta: {
          title: 'Romas progiciel',
        }
      }
    ]
  },
  {
    path: "/accueil",
    component: BodyView,
    children: [
      {
        path: "tableau-bord",
        name: "TableauBord",
        component: TableauBordPage,
        meta: {
          title: 'Tableau de bord',
        }
      },
    ]
  },

  {
    path: "/utilisateurs",
    component: BodyView,
    children: [
      {
        path: "ajouter-utilisateur",
        name: "AddUser",
        component: AddUserPage,
        meta: {
          title: 'Ajouter un utilisateur',
        }
      },
      {
        path: "liste-utilisateur",
        name: "ListeUser",
        component: ListeUserPage,
        meta: {
          title: 'Liste des utilisateurs',
        }
      },
      {
        path: "edit-utilisateur/:id",
        name: "EditUser",
        component: EditUserPage,
        meta: {
          title: 'Modifier un utilisateur',
        }
      },
      {
        path: "view-utilisateur/:id",
        name: "ViewUser",
        component: ViewUserPage,
        meta: {
          title: 'Détails d\'un utilisateur',
        }
      },
    ]
  },

  {
    path: "/motifSuivis",
    component: BodyView,
    children: [
      {
        path: "liste-motifSuivi",
        name: "ListeMotifSuivi",
        component: ListeMotifSuiviPage,
        meta: {
          title: 'Liste des motifs Suivis',
        }
      },
    ]
  },
  {
    path: "",
    component: BodyView,
    children: [
      {
        path: "profile",
        name: "EditProfile",
        component: EditProfilePage,
        meta: {
          title: 'Modifier mon profile',
        }
      }
    ]
  },
  {
    path: "/clients",
    component: BodyView,
    children: [
      {
        path: "ajouter-client",
        name: "AddClient",
        component: AddClientPage,
        meta: {
          title: 'Ajouter un client',
        }
      },
      {
        path: "modifier-client/:id",
        name: "EditClient",
        component: EditClientPage,
        meta: {
          title: 'Modifier un client',
        }
      },
      {
        path: "liste-clients",
        name: "ListeClient",
        component: ListeClientPage,
        meta: {
          title: 'Liste des clients',
        }
      },
      {
        path: "view-client/:id",
        name: "ViewClient",
        component: ViewClientPage,
        meta: {
          title: 'Détails d\'un client',
        }
      },
     
      {
        path: "transactions/clients/:id",
        name: "ClientsTransaction",
        component: ClientsTransactionPage,
        meta: {
          title: 'Les transactions d\'un client',
        }
      },
    ]
  },
  
   {
    path: "/paiements",
    component: BodyView,
    children: [
      {
        path: "ajouter-paiement",
        name: "AddPaiement",
        component: AddPaiementPage,
        meta: {
          title: 'Ajouter un paiement',
        }
      },
      // {
      //   path: "modifier-paiement/:id",
      //   name: "EditPaiement",
      //   component: EditPaiementPage,
      //   meta: {
      //     title: 'Modifier un paiement',
      //   }
      // },
      {
        path: "liste-paiements",
        name: "ListePaiement",
        component: ListePaiementPage,
        meta: {
          title: 'Liste des paiements',
        }
      },
     
      {
        path: "view-Paiement/:id",
        name: "ViewPaiement",
        component: ViewPaiementPage,
        meta: {
          title: 'Détails d\'un paiement',
        }
      },
    ]
  },
 
  
  {
    path: "/clientAffecter",
    component: BodyView,
    children: [

      {
        path: "/clientAffecter/liste-clientAffecter",
        name: "ListeClientAffecter",
        component: ListeClientAffecterPage,
        meta: {
          title: 'Liste des clients affectés',
        }
      },

      {
        path: "/clientAffecter/ajouter-clientAffecter",
        name: "AddClientAffecter",
        component: AddClientAffecterPage,
        meta: {
          title: 'Affecter un client',
        }
      },
      {
        path: "/clientAffecter/edit-clientAffecter/:id",
        name: "EditClientAffecter",
        component: EditClientAffecterPage,
        meta: {
          title: 'Editer des clients affectés',
        }
      },
    ]
  },


  {
    path: "/mesclients",
    component: BodyView,
    children: [

      {
        path: "/mesclients/liste-mesclients",
        name: "ListeMesClients",
        component: ListeMesClientsPage,
        meta: {
          title: 'Liste de mes clients',
        }
      },

      {
        path: "/clientAffecter/ajouter-clientAffecter",
        name: "AddClientAffecter",
        component: AddClientAffecterPage,
        meta: {
          title: 'Affecter un client',
        }
      },
      {
        path: "/clientAffecter/edit-clientAffecter/:id",
        name: "EditClientAffecter",
        component: EditClientAffecterPage,
        meta: {
          title: 'Editer des clients affectés',
        }
      },
    ]
  },


  {
    path: "/depots",
    component: BodyView,
    children: [
      {
        path: "liste-depots",
        name: "ListeDepot",
        component: ListeDepotPage,
        meta: {
          title: 'Liste des dépôts',
        }
      },
      {
        path: "ajouter-depot",
        name: "AddDepot",
        component: AddDepotPage,
        meta: {
          title: 'Ajouter un dépôt',
        }
      },
    ]
  },
  {
    path: "/transactions",
    component: BodyView,
    children: [
      {
        path: "ajouter-transaction",
        name: "AddTransaction",
        component: AddTransactionPage,
        meta: {
          title: 'Ajouter une transaction',
        }
      },
      {
        path: "modifier-transaction/:id",
        name: "EditTransaction",
        component: EditTransactionPage,
        meta: {
          title: 'Modifier une transaction',
        }
      },
     
      {
        path: "view-transaction/:id",
        name: "ViewTransaction",
        component: ViewTransactionPage,
        meta: {
          title: 'Détails de la transaction',
        }
      },
    ]
  },
  {
    path: "/type-comptes",
    component: BodyView,
    children: [
      {
        path: "liste-typecomptes",
        name: "ListeTypeCompte",
        component: ListeTypeComptePage,
        meta: {
          title: 'Liste des types de comptes',
        }
      },
    ]
  },
  

  {
    path: "/comptes",
    component: BodyView,
    children: [
      {
        path: "ajouter-compte",
        name: "AddCompte",
        component: AddComptePage,
        meta: {
          title: 'Ajouter un compte',
        }
      },
      {
        path: "modifier-compte/:id",
        name: "EditCompte",
        component: EditComptePage,
        props: true,
        meta: {
          title: 'Modifier un compte',
        }
      },
      {
        path: "liste-comptes",
        name: "ListeCompte",
        component: ListeComptePage,
        meta: {
          title: 'Liste des comptes',
        }
      },
    ]
  },
  {
    path: "/comptesentreprises",
    component: BodyView,
    children: [
      {
        path: "liste-comptes-entreprises",
        name: "ListeCompteEntreprise",
        component: ListeCompteEntreprisePage,
        meta: {
          title: 'Liste des trésoreries',
        }
      },
    ]
  },
 

  {
    path: "/permissions",
    component: BodyView,
    children: [
      {
        path: "ajouter-permission",
        name: "AddPermissionPage",
        component: AddPermissionPage,
        meta: {
          title: 'Ajouter une permission',
        }
      },
      {
        path: "liste-permission",
        name: "ListePermissionPage",
        component: ListePermissionPage,
        meta: {
          title: 'Liste des permissions',
        }
      }
    ]
  },



  {
    path: "/roles",
    component: BodyView,
    children: [
      {
        path: "ajouter-role",
        name: "AddRolePage",
        component: AddRolePage,
        meta: {
          title: 'Ajouter un role',
        }
      },
      {
        path: "liste-role",
        name: "ListeRolePage",
        component: ListeRolePage,
        meta: {
          title: 'Liste des rôles',
        }
      },
      {
        path: "edit-role/:id",
        name: "EditRolePage",
        component: EditRolePage,
        meta: {
          title: 'Modifier un rôle',
        }
      },
      {
        path: "view-role/:id",
        name: "ViewRolePage",
        component: ViewRolePage,
        meta: {
          title: 'Détails du rôle',
        }
      }
    ]
  },
  {
    path: "/familles",
    component: BodyView,
    children: [
      {
        path: "liste-familles",
        name: "ListeFamille",
        component: ListeFamillePage,
        meta: {
          title: 'Liste des catégories',
        }
      },
    ]
  },

  {
    path: "/produits",
    component: BodyView,
    children: [
      {
        path: "ajouter-produit",
        name: "AddProduit",
        component: AddProduitPage,
        meta: {
          title: 'Ajouter un produit',
        }
      },
      {
        path: "modifier-produit/:id",
        name: "EditProduit",
        component: EditProduitPage,
        meta: {
          title: 'Modifier un produit',
        }
      },
      
      {
        path: "view-produit/:id",
        name: "ViewProduit",
        component: ViewProduitPage,
        meta: {
          title: 'Détails d\'un produit',
        }
      },
      {
        path: "liste-produits",
        name: "ListeProduit",
        component: ListeProduitPage,
        meta: {
          title: 'Liste des produits',
        }
      },
      {
        path: '/produits/conditionnement/:id',
        name: 'AddProduitConditionnement',
        component: AddProduitConditionnementPage
      },
      
    ]
  },
  {
    path: "/magasins",
    component: BodyView,
    children: [
      {
        path: "liste-magasins",
        name: "ListeMagasin",
        component: ListeMagasinPage,
        meta: {
          title: 'Liste des magasins',
        }
      },
      {
        path: "ajouter-magasin",
        name: "AddMagasin",
        component: AddMagasinPage,
        meta: {
          title: 'Ajouter un magasin',
        }
      },
      {
        path: "modifier-magasin/:id",
        name: "EditMagasin",
        component: EditMagasinPage,
        meta: {
          title: 'Modifier un magasin',
        }
      },
    ]
  },

  //   {
  //   path: "/creances",
  //   component: BodyView,
  //   children: [
  //     {
  //       path: "ajouter-creance",
  //       name: "AddCreancePage",
  //       component: AddCreancePage,
  //       meta: {
  //         title: 'Ajouter une créance',
  //       }
  //     },
  //     {
  //       path: "modifier-creance/:id",
  //       name: "EditCreance",
  //       component: EditCreancePage,
  //       meta: {
  //         title: 'Modifier une créance',
  //       }
  //     },
  //     {
  //       path: "view-creance/:id",
  //       name: "ViewCreance",
  //       component: ViewCreancePage,
  //       meta: {
  //         title: 'Détails d\'une créance',
  //       }
  //     },
  //     {
  //       path: "liste-creances",
  //       name: "ListeCreance",
  //       component: ListeCreancePage,
  //       meta: {
  //         title: 'Liste des créances',
  //       }
  //     },
  //   ]
  // },


  {
    path: "/pieces",
    component: BodyView,
    children: [
      {
        path: "ajouter-piece",
        name: "AddPiece",
        component: AddPiecePage,
        meta: {
          title: 'Ajouter une pièce',
        }
      },

      {
        path: "liste-pieces",
        name: "ListePiece",
        component: ListePiecePage,
        meta: {
          title: 'Liste des pièces',
        }
      },
    ]
  },
 
  {
    path: "/reglements",
    component: BodyView,
    children: [
      {
        path: "ajouter-reglement",
        name: "AddReglement",
        component: AddReglementPage,
        meta: {
          title: 'Ajouter un règlement',
        }
      },

      {
        path: "liste-reglements",
        name: "ListeReglement",
        component: ListeReglementPage,
        meta: {
          title: 'Liste des règlements',
        }
      },
    ]
  },

  {
    path: "/mode-reglements",
    component: BodyView,
    children: [
      {
        path: "liste-mode-reglements",
        name: "ListeModeReglement",
        component: ListeModeReglement,
        meta: {
          title: 'Liste des modes de règlement'
        }
      },
      {
        path: "add-mode-reglement",
        name: "AddModeReglement",
        component: AddModeReglementModal,
        meta: {
          title: 'Ajouter un mode de règlement'
        }
      },
      


   
    ]
  },

  {
    path: "/inventaires",
    component: BodyView,
    children: [
      {
        path: "ajouter-inventaire",
        name: "AddInventaire",
        component: AddInventairePage,
        meta: {
          title: 'Ajouter un inventaire',
        }
      },
      {
        path: "edite-fiche-inventaire/:id",
        name: "EditeFicheInventaire",
        component: EditeFicheInventairePage,
        meta: {
          title: 'Edite fiche inventaire',
        }
      },

      {
        path: "detail-inventaire/:id",
        name: "DetailInventairePage",
        component: DetailInventairePage,
        meta: {
          title: 'Détail inventaire',
        }
      },
      {
        path: "inventorier",
        name: "MiseAJourInventaire",
        component: MiseAJourInventairePage,
        meta: {
          title: 'Inventorier',
        }
      },
      {
        path: "ajouter-mouvement",
        name: "AddMouvement",
        component: AddMouvementPage,
        meta: {
          title: 'Ajouter un mouvement',
        }
      },
      {
        path: "liste-mouvements",
        name: "ListeMouvement",
        component: ListMouvementPage,
        meta: {
          title: 'Liste des mouvements',
        }
      },
      {
        path: "ajouter-mouvement-fiche",
        name: "AddMouvementFiche",
        component: AddMouvementFichePage,
        meta: {
          title: 'Ajouter un mouvement fiche',
        }
      },
      {
        path: "liste-mouvements-fiche",
        name: "ListeMouvementFiche",
        component: ListeMouvementFichePage,
        meta: {
          title: 'Liste des mouvements des fiches',
        }
      },
      {
        path: "liste-fiche-inventaires",
        name: "ListeFicheInventaire",
        component: ListeFicheInventairePage,
        meta: {
          title: 'Liste des fiches d\'inventaires',
        }
      },

      {
        path: "liste-inventaires",
        name: "ListeInventaire",
        component: ListeInventairePage,
        meta: {
          title: 'Liste des inventaires',
        }
      },




      {
        path: "liste-produit-inventaire",
        name: "ListeProduitIventaire",
        component: ListeProduitIventairePage,
        meta: {
          title: 'Liste des produits inventoriers',
        }
      },
    ]
  },
 
      

  {
    path: "/demandes-prix",
    component: BodyView,
    children: [
      {
        path: "liste-demande-prix",
        name: "ListeDemandePrix",
        component: ListeDemandePrixPage,
        meta: {
          title: 'Liste des demandes de prix',
        }
      },
      {
        path: "ajouter-demande-prix",
        name: "AddDemandePrix",
        component: AddDemandePrixPage,
        meta: {
          title: 'Ajouter une demande de prix',
        }
      },
      {
        path: "modifier-demande-prix/:id",
        name: "EditDemandePrix",
        component: EditDemandePrixPage,
        meta: {
          title: 'Modifier une demande',
        }
      },
      {
        path: "view-demande-prix/:id",
        name: "ViewDemandePrix",
        component: ViewDemandePrixPage,
        meta: {
          title: 'Détails d\'une demande prix',
        }
      },

    ]
  },
  {
    path: "/bons-commandefournisseurs",
    component: BodyView,
    children: [
      {
        path: "liste-commandefournisseurs",
        name: "ListeBonCommandeFournisseur",
        component: ListeBonCommandeFournisseurPage,
        meta: {
          title: 'Liste des commandes fournisseurs',
        }
      },


      {
        path: "ajouter-boncommandefournisseur",
        name: "AddBonCommandeFournisseur",
        component: AddBonCommandeFournisseurPage,
        meta: {
          title: 'Commandes fournisseurs',
        }
      },
      {
        path: "view-bon-commandefournisseurs/:id",
        name: "ViewBonCommandeFournisseur",
        component: ViewBonCommandeFournisseurPage,
        meta: {
          title: 'Détails d\'un bon de commandes fournisseurs',
        }
      },

    ]
  },
  {
    path: "/fournisseurs",
    component: BodyView,
    children: [
      {
        path: "ajouter-fournisseur",
        name: "AddFournisseur",
        component: AddFournisseurPage,
        meta: {
          title: 'Ajouter un fournisseur',
        }
      },

      {
        path: "edit-fournisseur/:id",
        name: "EditFournisseur",
        component: EditFournisseurPage,
        meta: {
          title: 'Modifier un fournisseur',
        }
      },
      {
        path: "liste-fournisseurs",
        name: "ListeFournisseur",
        component: ListeFournisseurPage,
        meta: {
          title: 'Liste des fournisseurs',
        }
      },
      {
        path: "view-fournisseur/:id",
        name: "ViewFournisseur",
        component: ViewFournisseurPage,
        meta: {
          title: 'Détails d\'un fournisseur',
        }
      },

    ]
  },

  {
    path: "/ventes",
    component: BodyView,
    children: [
      {
        path: "ajouter-vente",
        name: "AddVente",
        component: AddVentePage,
        meta: {
          title: 'Ajouter une vente',
        }
      },

      {
        path: "transformer-proforma/:id",
        name: "TransformerProforma",
        component: TransformerProformaPage,
        meta: {
          title: 'Transformer une facture proforma',
        }
      },
      {
        path: "liste-ventes",
        name: "ListeVente",
        component: ListeVentePage,
        meta: {
          title: 'Liste des ventes',
        }
      },
      {
        path: "view-Vente/:id",
        name: "ViewVente",
        component: ViewVentePage,
        meta: {
          title: 'Détails d\'une vente',
        }
      },

    ]
  },

  {
    path: "/etats",
    component: BodyView,
    children: [
      {
        path: "produits-disponibles",
        name: "EtatProduitsDisponibles",
        component: EtatProduitsDisponibles,
        meta: {
          title: 'Stock du produit',
        }
      },
      {
        path: "produits-livres",
        name: "EtatPointProduitLivraisonPage",
        component: EtatPointProduitLivraisonPage,
        meta: {
          title: 'Liste des produits livrés par période',
        }
      },
      {
        path: "etat-nmbre-pro",
        name: "EtatNombreProduitVenduPage",
        component: EtatNombreProduitVenduPage,
        meta: {
          title: 'Produits vendus par période',
        }
      },
      {
        path: "ca-client",
        name: "EtatChiffreAffaireClientPage",
        component: EtatChiffreAffaireClientPage,
        meta: {
          title: `Chiffre d'affaire par Client`,
        }
      },
      {
        path: "produits-vendus",
        name: "EtatPointVentePage",
        component: EtatPointVentePage,
        meta: {
          title: 'Liste des produits vendus',
        }
      },
      {
        path: "produits-rupture",
        name: "EtatProduitsRupturePage",
        component: EtatProduitsRupturePage,
        meta: {
          title: 'Liste des produits en rupture de stock',
        }
      },
      {
        path: "point-commande",
        name: "EtatPointCommandePage",
        component: EtatPointCommandePage,
        meta: {
          title: 'Liste du point des commandes',
        }
      },
      {
        path: "etat-produits-entree",
        name: "EtatProduitsEntreePage",
        component: EtatProduitsEntreePage,
        meta: {
          title: 'Liste des produits entrées',
        }
      },
      {
        path: "etats-produits-sorties",
        name: "EtatProduitsSortiesPage",
        component: EtatProduitsSortiesPage,
        meta: {
          title: 'Liste des produits sorties',
        }
      },
    ]
  },

  {
    path: "/detachements",
    component: BodyView,
    children: [
      {
        path: "ajouter-detachement",
        name: "AddDetachement",
        component: AddDetachementPage,
        meta: {
          title: 'Ajouter un detachement',
        }
      },
      
      {
        path: "liste-detachements",
        name: "ListeDetachement",
        component: ListeDetachementPage,
        meta: {
          title: 'Liste des détachements',
        }
      },
      {
        path: "view-Detachement/:id",
        name: "ViewDetachement",
        component: ViewDetachementPage,
        meta: {
          title: 'Détails d\'un détachement',
        }
      },
    ]
  },

  {
    path: "/sorties",
    component: BodyView,
    children: [
      {
        path: "ajouter-sortie",
        name: "AddSortie",
        component: AddSortiePage,
        meta: {
          title: 'Ajouter une sortie',
        }
      },
      {
        path: "modifier-sortie/:id",
        name: "EditSortie",
        component: EditSortiePage,
        meta: {
          title: 'Modifier une sortie',
        }
      },
      {
        path: "liste-sorties",
        name: "ListeSortie",
        component: ListeSortiePage,
        meta: {
          title: 'Liste des sorties',
        }
      },
      {
        path: "view-sortie/:id",
        name: "ViewSortie",
        component: ViewSortiePage,
        meta: {
          title: 'Détails d\'une sortie',
        }
      },
    ]
  },

  {
    path: "/transferts",
    component: BodyView,
    children: [
      {
        path: "ajouter-transfertMag",
        name: "AddTransfert",
        component: AddTransfertMagPage,
        meta: {
          title: 'Ajouter un transfert par magasin',
        }
      },
      {
        path: "ajouter-transfertPointDeVente",
        name: "AddTransfertPointVentePage",
        component: AddTransfertPointVentePage,
        meta: {
          title: 'Ajouter un transfert par point de vente',
        }
      },
     
      {
        path: "liste-transferts",
        name: "ListeTransfert",
        component: ListeTransfertPage,
        meta: {
          title: 'Liste des transfert',
        }
      },
      {
        path: "liste-transfertMag",
        name: "ListeTransfertMagasin",
        component: ListeTransfertMagasinPage,
        meta: {
          title: 'Liste des transfert Par Magasin',
        }
      },
      {
        path: "view-transfertMag/:id",
        name: "ViewTransfertMagasin",
        component: ViewTransfertMagasinPage,
        meta: {
          title: 'Détails d’un transfert interne de magasin',
        }
      },
      {
        path: "view-transfert/:id",
        name: "ViewTransfert",
        component: ViewTransfertPage,
        meta: {
          title: 'Détails d\'un transfert par point de vente',
        }
      },
    ]
  },



  {
    path: "/approvisionnements",
    component: BodyView,
    children: [
      {
        path: "ajouter-approvisionnement",
        name: "AddApprovisionnement",
        component: AddApprovisionnementPage,
        meta: {
          title: 'Ajouter un approvisionnement',
        }
      },
      {
        path: "liste-approvisionnements",
        name: "ListeApprovisionnement",
        component: ListeApprovisionnementPage,
        meta: {
          title: 'Liste des approvisionnements',
        }
      },
      {
        path: "view-approvisionnement/:id",
        name: "ViewApprovisionnement",
        component: ViewApprovisionnementPage,
        meta: {
          title: 'Détails d\'un approvisionnement',
        }
      },
    ]
  },

  {
    path: "/livraisons",
    component: BodyView,
    children: [
      {
        path: "ajouter-livraison",
        name: "AddLivraison",
        component: AddLivraisonPage,
        meta: {
          title: 'Ajouter une livraison',
        }
      },
      {
        path: "liste-livraisons",
        name: "ListeLivraison",
        component: ListeLivraisonPage,
        meta: {
          title: 'Liste des livraisons',
        }
      },
      {
        path: "view-livraison/:id",
        name: "ViewLivraison",
        component: ViewLivraisonPage,
        meta: {
          title: 'Détails d\'une livraison',
        }
      },
    ]
  },

  
      {
        path: "/monnaies",
        component: BodyView,
        children: [
          {
            path: "ajouter-monnaie",
            name: "AddMonnaie",
            component: AddMonnaiePage,
            meta: {
              title: 'Ajouter une monnaie',
            }
          },
          {
            path: "liste-monnaies",
            name: "ListeMonnaie",
            component: ListeMonnaiePage,
            meta: {
              title: 'Liste des monnaies',
            }
          },

        ]
      },

  {
    path: "/caisses",
    component: BodyView,
    children: [
      {
        path: "ajouter-caisse",
        name: "AddCaisse",
        component: AddCaissePage,
        meta: {
          title: 'Ajouter une caisse',
        }
      },
     
        {
        path: "affecter-caisse/:caisseId",
        name: "AffectationCaissePage",
        component: AffectationCaisseModalPage,
        meta: {
          title: 'Affecter une caisse',
        }
      },
       {
        path: "historique-affectations/:caisseId",
        name: "HistoriquePage",
        component: HistoriquePage,
        meta: {
          title: 'Historique des affectations de caisse',
        }
      },
      {
        path: "/OuverturesFermetures",
        name: "ListeOuvFerm",
        component: ListeOuvFermPage,
      },

      {
        path: "/MonnaiesDisponibles",
        name: "ListeMonnaiesDisponibles",
        component: ListeMonnaiesDisponiblesPage,
      },

      {
        path: '/ouverture/:id',
        name: 'ViewOuvFermPage',
        component: ViewOuvFermPage,
      },
       {
        path: '/confirmation',
        name: 'ConfirmationPaiementPage',
        component: ConfirmationPaiementPage,
      },
      {
        path: "liste-caisses",
        name: "ListeCaisse",
        component: ListeCaissePage,
        meta: {
          title: 'Liste des caisses',
        }
      },

      {
        path: "/ajouter-ouvfer",
        name: "AddOuvFermPage",
        component: AddOuvFermPage,
      },
      {
        path: "/ajouter-fer/:id",
        name: "AddFermPage",
        component: AddFermPage,
      },
       {
      path: "/ajouter-encaissement",
      name: "AddEncaissementPage",
      component: AddEncaissementPage,
    },

    {
      path: "/ajouter-decaissement",
      name: "AddDecaissementPage",
      component: AddDecaissementPage,
    },
    {
      path: "/faire-conversion",
      name: "ConversionMonnaiePage",
      component: ConversionMonnaiePage,
    },

    {
      path: "/liste-operations",
      name: "ListeOperationPage",
      component: ListeOperationPage,
    },
    ]
  },
  {
    path: "/modele-signataires",
    component: BodyView,
    children: [
      {
        path: "ajouter-modele-signataire",
        name: "AddModeleSignataire",
        component: AddModeleSignatairePage,
        meta: {
          title: 'Ajouter un modèle de signataire',
        }
      },
      {
        path: "liste-modele-signataires",
        name: "ListeModeleSignataire",
        component: ListeModeleSignatairePage,
        meta: {
          title: 'Liste des modèles de signataires',
        }
      },
    ]
  },


  {
    path: "/factures",
    component: BodyView,
    children: [
      {
        path: "liste-factures",
        name: "ListeFacture",
        component: ListeFacturePage,
        meta: {
          title: 'Liste des factures',
        }
      },
      {
        path: "liste-facture-proformas",
        name: "ListeFactureProforma",
        component: ListeFactureProformaPage,
        meta: {
          title: 'Liste des factures proformas',
        }
      },
    ]
  },

  {
    path: "/conditionnements",
    component: BodyView,
    children: [
      {
        path: "liste-conditionnements",
        name: "ListeConditionnement",
        component: ListeConditionnementPage,
        meta: {
          title: 'Liste des conditionnements',
        }
      },

    ]
  },
 
  {
    path: "/",
    component: BodyView,
    children: [
      {
        path: "liste-groupe-taxes",
        name: "ListeGroupeTaxe",
        component: ListeGroupeTaxePage,
        meta: {
          title: 'Liste des groupes de taxes',
        }
      },
      {
        path: "liste-taxes",
        name: "ListeTaxe",
        component: ListeTaxePage,
        meta: {
          title: 'Liste des taxes',
        }
      },
      {
        path: "liste-type-taxes",
        name: "ListeTypeTaxe",
        component: ListeTypeTaxePage,
        meta: {
          title: 'Liste des types de taxes',
        }
      },
    ]
  },
   {
    path: "/societes",
    component: BodyView,
    children: [
      {
        path: "ajouter-societe",
        name: "AddSociete",
        component: AddSocietePage,
        meta: {
          title: 'Ajouter une société',
        }
      },
      {
        path: "modifier-societe/:id",
        name: "EditSociete",
        component: EditSocietePage,
        meta: {
          title: 'Modifier une société',
        }
      },
      {
        path: "liste-societes",
        name: "ListeSociete",
        component: ListeSocietePage,
        meta: {
          title: 'Liste des sociétés',
        }
      },
      {
        path: "view-societe/:id",
        name: "ViewSociete",
        component: ViewSocietePage,
        meta: {
          title: 'Détails d\'une société',
        }
      },
    ]
  },
  

  {
    path: "/point-ventes",
    component: BodyView,
    children: [
      {
        path: "ajouter-point-vente",
        name: "AddPointVente",
        component: AddPointVentePage,
        meta: {
          title: 'Ajouter un point de vente',
        }
      },
      {
        path: "modifier-point-vente/:id",
        name: "EditPointVente",
        component: EditPointVentePage,
        meta: {
          title: 'Modifier un point de vente',
        }
      },
      {
        path: "liste-point-ventes",
        name: "ListePointVente",
        component: ListePointVentePage,
        meta: {
          title: 'Liste des points de vente',
        }
      },
    ]
  },

  {
    path: "/auth",
    component: AuthView,
    children: [
      {
        path: "login",
        name: "login",
        component: LoginPage,
        meta: {
          title: 'SOMIMAS - Connexion',
        }
      },
      {
        path: "reset_password_first",
        name: "ResetPasswordFirst",
        component: ResetPasswordFirstPage,
        meta: {
          title: 'Reset Password | SOMIMAS',
        }
      },
    ]
  },
  {
    path: "/dashboards",
    component: BodyView,
    children: [
      {
        path: "dashboard_default",
        name: "default",
        component: indexDefault,
        meta: {
          title: 'Dashboards | Mofi - Premium Vue Admin Template',
        }
      },
      {
        path: "dashboard_project",
        name: "project",
        component: indexProject,
        meta: {
          title: 'Dashboards CRM | Mofi - Premium Vue Admin Template',
        }
      },
    ]
  },
  {
    path: "/authentication/simple",
    name: "loginsimple",
    component: loginSimple,
    meta: {
      title: 'Login Simple | Mofi - Premium Vue Admin Template',
    }
  },
  {
    path: "/authentication/login/one",
    name: "loginimage",
    component: loginImage,
    meta: {
      title: 'Login Image | Mofi - Premium Vue Admin Template',
    }
  },
  {
    path: "/authentication/login/two",
    name: "loginImagetwo",
    component: loginImageTwo,
    meta: {
      title: 'Login Image Two | Mofi - Premium Vue Admin Template',
    }
  },
  {
    path: "/authentication/login/validate",
    name: "loginValidation",
    component: loginValidation,
    meta: {
      title: 'Login Validation | Mofi - Premium Vue Admin Template',
    }
  },
  {
    path: "/authentication/login/tooltip",
    name: "loginTooltip",
    component: loginTooltip,
    meta: {
      title: 'Login Tooltip | Mofi - Premium Vue Admin Template',
    }
  },
  {
    path: "/authentication/login/sweetalert",
    name: "loginSweetalert",
    component: loginSweetalert,
    meta: {
      title: 'Login Sweetalert | Mofi - Premium Vue Admin Template',
    }
  },
  {
    path: "/authentication/register/two",
    name: "registerImagetwo",
    component: registerImageTwo,
    meta: {
      title: 'Register Image Two | Mofi - Premium Vue Admin Template',
    }
  },
  {
    path: "/auth/register",
    name: "registerSimple",
    component: registerSimple,
    meta: {
      title: 'Register | Mofi - Premium Vue Admin Template',
    }
  },
  {
    path: "/authentication/register/one",
    name: "registerImage",
    component: registerImage,
    meta: {
      title: 'Register Image | Mofi - Premium Vue Admin Template',
    }
  },
  {
    path: "/authentication/unlock_user",
    name: "unlockUser",
    component: unlockUser,
    meta: {
      title: 'Unlock User | Mofi - Premium Vue Admin Template',
    }
  },
  {
    path: "/authentication/forget_password",
    name: "forgetPassword",
    component: forgetPassword,
    meta: {
      title: 'Forget Password | Mofi - Premium Vue Admin Template',
    }
  },
  {
    path: "/authentication/reset_password",
    name: "resetPassword",
    component: resetPassword,
    meta: {
      title: 'Reset Password | Mofi - Premium Vue Admin Template',
    }
  },
  {
    path: "/authentication/maintenance",
    name: "maintenanceView",
    component: maintenanceView,
    meta: {
      title: 'Maintenance | Mofi - Premium Vue Admin Template',
    }
  }
]
const router = createRouter({
  
  history: createWebHashHistory(),
  linkExactActiveClass: "active",
  routes,
  
});

router.beforeEach(async (to, from, next) => {
  if (typeof (to.meta.title) === 'string') {
    document.title = to.meta.title;
  }
  ApiService.setHeader();
  const authStore = useAuthStore();
  await authStore.verifyAuth();
  const path = ['/auth/login', '/auth/register', '/auth/reset_password_first'];
  if (path.includes(to.path) || authStore.isAuthenticated) {
    next();
  } else {
    next('/auth/login');
  }
});

export default router
